import common from './common.js'
import fun from './function.js'
import role from './role.js'
import user from './user.js'
import operateLog from './operateLog.js'
import sys from './sys'
import funMenu from './fun'
import organization from './organization'

export default {
  common,
  fun,
  role,
  user,
  operateLog,
  sys,
  funMenu,
  organization
}



// WEBPACK FOOTER //
// ./src/api/apis/sys/index.js